import {Action} from "@ngrx/store";

export const LOAD_BACKUP: string = '[backup] Load Backup';
export const LOAD_BACKUP_SUCCESS: string = '[backup] Load Backup success';
export const LOAD_BACKUP_FAIL: string = '[backup] Load Backup Fail';

export const LOAD_BACKUP_NOW: string = '[backup] Load Backup Now';
export const LOAD_BACKUP_NOW_SUCCESS: string = '[backup] Load Backup Now success';
export const LOAD_BACKUP_NOW_FAIL: string = '[backup] Load Backup Now Fail';

export class LoadBackup implements Action {

  readonly type: string = LOAD_BACKUP;
  constructor(public payload: number) {}

}

export class LoadBackupSuccess implements Action {

  readonly type: string = LOAD_BACKUP_SUCCESS;
  constructor(public payload: {
    [id: string]: any
  }) {}

}

export class LoadBackupFail implements Action {

  readonly type: string = LOAD_BACKUP_FAIL;
  constructor(public payload: string) {}

}


export class LoadBackupNow implements Action {

  readonly type: string = LOAD_BACKUP_NOW;
  constructor(public payload: {
    websiteId: number,
    jobId: any
  }) {}

}

export class LoadBackupNowSuccess implements Action {

  readonly type: string = LOAD_BACKUP_NOW_SUCCESS;
  constructor(public payload: {
    websiteId: number,
    jobId: any,
    entities: {[websiteId: number]: any},
  }) {}

}

export class LoadBackupNowFail implements Action {

  readonly type: string = LOAD_BACKUP_NOW_FAIL;
  constructor(public payload: string) {}

}

export type BackupAction = LoadBackup | LoadBackupSuccess | LoadBackupFail | LoadBackupNow | LoadBackupNowSuccess | LoadBackupNowFail;
